<script setup lang="ts">
defineProps<{
  card: { id: string; hasNoData: boolean };
  zIndex: number;
}>();
</script>
<template>
  <div class="relative" ref="cardRef">
    <div
      class="h-280px xl:h-[342px] 2xl:h-[512px] 3xl:h-[1024px] xl:border-4 3xl:border-12 bg-white rounded-2.5 shadow-md flex flex-col border-[#D5D7DB]"
    >
      <div
        v-if="card.hasNoData"
        :style="{ 'z-index': zIndex + 1 }"
        class="absolute top-45% left--2rem text-center w-full text-[#828282] text-sm xl:text-3 2xl:text-4.5 3xl:text-9 3xl:line-height-3rem font-bold"
      >
        There are no new responses. <br />Please check again later.
      </div>
      <div
        class="bg-[#F5F5F5] xl:pt-2 xl:pb-2 xl:pl-10 xl:pr-10 2xl:pt-6 2xl:pb-6 2xl:pl-10 2xl:pr-10 3xl:pt-10 3xl:pb-10 3xl:pl-16 3xl:pr-16 flex flex-row h-auto items-center rounded-[0.625rem_0.625rem_0_0]"
      >
        <svg class="w-10 2xl:w-14 3xl:w-26" viewBox="0 0 73 71" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5 0C2.23858 0 0 2.23858 0 5V57C0 59.7614 2.23857 62 5 62H9.90967L13.2735 70.2152L22.1682 62H68C70.7614 62 73 59.7614 73 57V5C73 2.23858 70.7614 0 68 0H5Z"
            fill="#FFFFFF"
          />
        </svg>
        <div class="h-full w-full inline-block pl-5 2xl:pl-6 3xl:pl-9 align-sub 2xl:align-top">
          <p class="loading-gradient w-30% rounded-6 mt-2 bg-white 2xl:mt-6"></p>
          <p class="loading-gradient w-20% rounded-6 mb-2 ml-auto mt-0 bg-white 2xl:mb-6"></p>
        </div>
      </div>
      <div
        class="xl:pl-10 xl:pr-10 xl:mt-4 2xl:mt-6 min-h-0 mb-auto 2xl:pl-10 2xl:pr-10 3xl:pt-20 3xl:pb-20 3xl:pl-20 3xl:pr-20"
      >
        <div class="loading-gradient w-90% rounded-6 mt-2 2xl:mt-4 3xl:mt-6"></div>
        <div class="loading-gradient w-90% rounded-6 mt-2 2xl:mt-4 3xl:mt-6"></div>
        <div class="loading-gradient w-90% rounded-6 mt-2 2xl:mt-4 3xl:mt-6"></div>
        <div class="loading-gradient w-60% rounded-6 mt-2 2xl:mt-4 3xl:mt-6"></div>
      </div>
      <div
        class="border-t-2 border-[#D5D7DB] pl-10 pr-10 xl:pt-4 xl:pb-4 2xl:pt-6 3xl:pt-10 2xl:text-6 rounded-[0_0_0.625rem_0.625rem] pb-3 2xl:pb-6 3xl:pb-10 3xl:pl-20 3xl:pr-20 3xl:border-t-4"
      >
        <div class="flex flex-row space-x-1rem xl:space-x-2rem 2xl:space-x-2.5rem 3xl:space-x-5rem overflow-hidden">
          <div
            v-for="i in 3"
            :key="i"
            class="w-15% rounded-6 uppercase whitespace-nowrap pr-3 2xl:pr-4 3xl:pr-4 pb-1 loading-gradient 3xl:pb-2 mt-2 2xl:mt-4 3xl:mt-6"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
@media only screen and (min-width: 1080px) {
  p.loading-gradient,
  div.loading-gradient {
    height: 20px;
  }
}
@media only screen and (min-width: 1920px) {
  p.loading-gradient,
  div.loading-gradient {
    height: 25px;
  }
}
@media only screen and (min-width: 3840px) {
  p.loading-gradient,
  div.loading-gradient {
    height: 40px;
  }
}
</style>
